export const isSSR = typeof process !== 'undefined' && !process.browser
